module.exports = __webpack_public_path__ + "static/media/onTime.258035ca.svg";